// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__JrOE6","text":"PageHeader_text__NNhJy","title":"PageHeader_title__EOowK","subtitle":"PageHeader_subtitle__fPIm-","actions":"PageHeader_actions__KhHn3"};